
import icon from '@/components/icons/icon.vue'

export default {
	name: 'IconCheckboxCheck',
	components: { icon },
	props: {
		width: {
			type: [Number, String],
			default: 18,
		},
		height: {
			type: [Number, String],
			default: 18,
		},
	},
}
